export const API_KEY = "AIzaSyCamDs1OnekBiX-onGhZBNfHL8kDUinQvA";
export default API_KEY;

//https://developers.google.com/custom-search/v1/using_rest
//https://cse.google.com/cse/setup/basic?cx=bd5860cbe6515c864
